export default __webpack_public_path__ + "static/media/Corona.ce346e44.png";